import { PatientDtoGender } from '../api/generated/model';

export function getGenderName(gender: PatientDtoGender) {
  switch (gender) {
    case PatientDtoGender.MALE:
      return 'Männlich';
    case PatientDtoGender.FEMALE:
      return 'Weiblich';
    case PatientDtoGender.OTHER:
      return 'Andere';
    case PatientDtoGender.UNKNOWN:
      return 'Unbekannt';
  }
}
